/**
 * 時刻の表記。**日本時間で、人が読める形にする**。
 *
 * API は UTC の ISO 8601 をそのまま返す（機械どうしの受け渡しはそれが正しい）。
 * ただし生の `2026-09-19T12:34:56.000Z` を画面に出すと、読む人は 9 時間ずれた
 * 時刻を自分の頭で足すことになる。取り違えたまま「いつの集計か」を判断すると、
 * 古い数字を新しいものと読む。
 *
 * ブラウザのタイムゾーンに任せない（この管理画面を見るのは日本の事業者で、
 * 端末の設定が違っても同じ時刻が読めるほうがよい）。
 */

const FORMATTER = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

/**
 * 日本時間の「2026/09/19 21:34」。
 *
 * null（＝記録が無い）と、解釈できない値は**区別して返す**。どちらも
 * 呼び出し側が文言で言い分けられるように、ここでは null を返す。
 */
export function formatJst(value: string | null | undefined): string | null {
  if (value == null || value === "") {
    return null;
  }
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) {
    return null;
  }
  return `${FORMATTER.format(at)}`;
}

/** 「2026/09/19 21:34（日本時間）」。時刻だけを単体で置くときに使う */
export function formatJstWithZone(value: string | null | undefined): string {
  const formatted = formatJst(value);
  return formatted === null ? "記録がありません" : `${formatted}（日本時間）`;
}
